import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_public/coaching-business/playbooks")({
  staticData: { title: "Playbooks" },
  component: () => <Outlet />,
});
